"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const CustomCheckBox_1 = __importDefault(require("./CustomCheckBox"));
const RadioInput_1 = __importDefault(require("../../EHD/components/RadioInput"));
const MessageSettings = ({ fields, values, setFieldValue, setWarning }) => {
    const { homeEMail, homeMobilePhone } = values;
    (0, react_1.useEffect)(() => {
        if (values.homeEMail.length === 0 && values.invitations.includes('sendInvitationsByEMail')) {
            setFieldValue('invitations', values.invitations.filter((x) => x !== 'sendInvitationsByEMail'));
            setWarning({ type: 'email', message: __.trans('user.contact-info-email-warning') });
        }
        if (values.homeEMail.length === 0 && values.reminders.includes('sendRemindersByEMail')) {
            setFieldValue('reminders', values.reminders.filter((x) => x !== 'sendRemindersByEMail'));
            setWarning({ type: 'email', message: __.trans('user.contact-info-email-warning') });
        }
        if (values.homeMobilePhone.length === 0 &&
            values.invitations.includes('sendInvitationsBySMS')) {
            setFieldValue('invitations', values.invitations.filter((x) => x !== 'sendInvitationsBySMS'));
            setWarning({ type: 'sms', message: __.trans('user.contact-info-sms-warning') });
        }
        if (values.homeMobilePhone.length === 0 && values.reminders.includes('sendRemindersBySMS')) {
            setFieldValue('reminders', values.reminders.filter((x) => x !== 'sendRemindersBySMS'));
            setWarning({ type: 'sms', message: __.trans('user.contact-info-sms-warning') });
        }
        if (values.homeMobilePhone.length === 0 && values.awards.includes('sendAwardMessages')) {
            setFieldValue('awards', values.awards.filter((x) => x !== 'sendAwardMessages'));
            setWarning({ type: 'sms', message: __.trans('user.contact-info-sms-warning') });
        }
    }, [
        values.homeEMail,
        values.homeMobilePhone,
        values.invitations,
        values.reminders,
        values.awards,
        setFieldValue,
        setWarning,
    ]);
    const generateFields = () => {
        const groups = [...new Set(fields.map((item) => item.group))];
        return groups.map((group) => {
            const headerId = `header-${group}`;
            const inputs = fields
                .filter((x) => x.group === group)
                .map((item) => {
                if ((item === null || item === void 0 ? void 0 : item.type) === 'hidden') {
                    return null;
                }
                const disabled = (item.key.includes('SMS') && !homeMobilePhone) ||
                    (item.key.includes('EMail') && !homeEMail);
                const omittedValues = _.omit(values, ['homeEMail', 'homeMobilePhone']);
                const groupValue = omittedValues[group];
                return item.type === 'radio' ? ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(RadioInput_1.default, { name: group, value: item.key, label: __.trans(`contact-info.sendAwardMessagesYes`), disabled: !homeMobilePhone, onChange: () => {
                                setFieldValue(group, [...groupValue, item.key]);
                            }, checked: groupValue.includes(item.key), ariaLabelledBy: __.trans('contact-info.sendAwardMessagesYesAriaLabel') }), (0, jsx_runtime_1.jsx)(RadioInput_1.default, { name: group, value: false, label: __.trans(`contact-info.sendAwardMessagesNo`), onChange: () => {
                                setFieldValue(group, groupValue.filter((x) => x !== item.key));
                            }, checked: !groupValue.includes(item.key), ariaLabelledBy: __.trans(`contact-info.sendAwardMessagesNoAriaLabel`) })] }, item.key)) : ((0, jsx_runtime_1.jsx)(CustomCheckBox_1.default, { name: group, value: item.key, label: item.name, disabled: disabled, ariaLabelledBy: `${headerId}` }, item.key));
            });
            const onlyNullValues = inputs === null || inputs === void 0 ? void 0 : inputs.every((x) => x === null);
            return ((0, jsx_runtime_1.jsx)("div", { children: !onlyNullValues ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h5", { id: headerId, className: "py-1", children: (0, jsx_runtime_1.jsx)("strong", { children: __.trans(`user.address-group-${group}`) }) }), (0, jsx_runtime_1.jsx)("div", { className: "checkbox-group", children: (0, jsx_runtime_1.jsx)("div", { role: "group", "aria-labelledby": `checkbox-group-${group}`, className: `checkbox-group-${group}`, children: inputs }) })] })) : null }, group));
        });
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "message-settings", children: (0, jsx_runtime_1.jsxs)("div", { className: "py-3", children: [(0, jsx_runtime_1.jsx)("h5", { children: __.trans('user.messages') }), generateFields()] }) }));
};
exports.default = MessageSettings;
